import StoreCreditAPI from '@/app/apis/main/store-credit/store-credit-api.js';

export default {
	/**
	 * @return 204
	 * @params creditDetails
	 */
	async updateStoreCredit(customerId, creditDetails) {
		return StoreCreditAPI.updateStoreCredit(customerId, creditDetails)
	}
}